import { responseTypes } from '../../constants'

export const isCorrectOrIncorrect = responseType =>
    responseTypes.CORRECT === responseType ||
    responseTypes.INCORRECT === responseType
